import { makeStyles } from '@material-ui/core'
import { LineProps } from './Type'

export const useStyle = makeStyles((theme) => {
  return {
    line: (props: LineProps) => ({
      width: '100%',
      height: 1,
      background: theme.palette.secondary.light,
      margin: `${props.marginTopBottom} 0`,
    }),
  }
})
